import Cookie from '../utils/Cookie';
import { TOKEN_KEY } from '../utils/constants';
import { clearConnectCache } from '../components/stripe/connectInstanceCache';
import { clearEarningsCache } from '../utils/earningsCache';
import { clearSubscribersCache } from '../utils/subscribersCache';
import { SocketDisconnect } from '../socket';

export function clearAuthCache() {
  try {
    sessionStorage.clear();
    localStorage.clear();
  } catch {
    // ignore quota / private-mode failures
  }
  Cookie.deleteCookie(TOKEN_KEY);
  Cookie.deleteCookie('userType');
  Cookie.deleteCookie('__session');
}

export async function hardSignOut(signOut) {
  try {
    clearConnectCache();
    clearEarningsCache();
    clearSubscribersCache();
    SocketDisconnect();
  } catch {
    // still sign out
  }
  try {
    if (typeof signOut === 'function') {
      await signOut();
    }
  } catch {
    // still wipe local state
  }
  clearAuthCache();
  window.location.replace('/login');
}
